import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import styled from "styled-components"
import Img from "gatsby-image"
import { StyledTitle } from "../components/Title"
import * as authors from "../data/authors"
import mailIcon from "../images/icons/socials/mail-blue.svg"
import linkedIcon from "../images/icons/socials/linked-in-blue.svg"

const StyledCard = styled.div`
  padding: 16px;
  display: flex;
  align-items: center;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 12px 18px 0 rgba(0, 0, 0, 0.05), 0 4px 6px 0 rgba(0, 0, 0, 0.1);
  margin: 18px 0 32px;
  & .profile-content {
    margin-left: 16px;
    & p {
      font-size: 13px;
      letter-spacing: 0.5px;
      opacity: 0.6;
    }
    @media (min-width: 768px) {
      margin-left: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }
  @media (min-width: 768px) {
    flex-direction: column;
    justify-content: flex-end;
    padding: 85px 0 40px;
    position: relative;
    width: auto;
    margin: 0;
  }
  @media (min-width: 1024px) {
    width: 270px;
  }
`

const Avatar = styled(Img)`
  width: 100px;
  @media (min-width: 768px) {
    position: absolute !important;
    left: 50%;
    top: 0;
    transform: translate(-50%, -50%);
    width: 130px;
  }
`

const ExtendStyledTitle = styled(StyledTitle)`
  font-size: 20px;
  letter-spacing: 0.5px;
  font-family: "Made Medium", sans-serif;
  padding-bottom: 8px;
  margin-bottom: 8px;
  @media (min-width: 768px) {
    font-size: 24px;
    text-align: center;
    padding-bottom: 10px;
    margin-bottom: 10px;
    &::after {
      left: 50%;
      transform: translateX(-50%);
    }
  }
`

const Socials = styled.div`
  display: flex;
  margin-top: 8px;
  align-items: flex-end;
  & a {
    margin-right: 16px;
    & img {
      transition: all 0.15s ease;
    }
    &:hover {
      img {
        transform: scale(1.1);
      }
    }
  }
  @media (min-width: 768px) {
    margin-top: 20px;
    align-items: center;
    justify-content: space-evenly;
    & a {
      width: 24px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 8px;
      & img {
        width: 24px;
        height: 24px;
      }
    }
  }
`

const StyledSecondCard = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-shadow: 0 12px 18px 0 rgba(0, 0, 0, 0.05), 0 4px 6px 0 rgba(0, 0, 0, 0.1);
  background-color: #fff;
  border-radius: 8px;
  padding: 16px;
  text-align: center;
  width: 243px;
  position: relative;
  ${Avatar} {
    width: 70px;
    height: 70px;
    margin: 0 auto;
  }
  ${ExtendStyledTitle} {
    font-size: 24px;
    text-align: center;
    margin: 8px 0;
    padding-bottom: 0;
    &::after {
      display: none;
    }
  }
  .job {
    position: relative;
    margin-bottom: 8px;
    padding-bottom: 8px;
    opacity: 0.6;
    &::after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 70px;
      height: 2px;
      background-color: #c39779;
    }
  }
  .desc {
    font-size: 16px;
    font-family: "Made Light", sans-serif;
    letter-spacing: 0.3px;
    line-height: 25px;
    opacity: 0.6;
  }
  ${Socials} {
    margin: 20px auto 0;
    display: flex;
    justify-content: center;
    align-items: center;
    & a {
      margin: 0 8px;
    }
  }
  @media (min-width: 768px) {
    flex-direction: column;
    justify-content: flex-start;
    padding: 30px 16px 20px;
    position: relative;
    width: auto;
    margin: 0;
    & .profile-content {
      padding: 0;
    }
  }
  @media (min-width: 1024px) {
    width: 270px;
    padding: 75px 20px 30px;
    ${Avatar} {
      width: 130px;
      height: 130px;
    }
    .desc {
      font-size: 20px;
      line-height: 32px;
    }
    ${ExtendStyledTitle} {
      line-height: normal;
      margin-bottom: 10px;
    }
    .job {
      margin-bottom: 10px;
      padding-bottom: 10px;
    }
  }
  @media (min-width: 1200px) {
    width: auto;
  }
`
export const useAvatars = () => {
  const {
    mainAvatarAdam,
    mainAvatarMarcel,
    mainAvatarWojtek,
  } = useStaticQuery(graphql`
    query {
      mainAvatarAdam: file(relativePath: { eq: "avatars/adam.png" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      mainAvatarMarcel: file(relativePath: { eq: "avatars/marcel.png" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      mainAvatarWojtek: file(relativePath: { eq: "avatars/wojtek.png" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)
  return [mainAvatarMarcel, mainAvatarAdam, mainAvatarWojtek]
}

const arrAuthors = [
  authors.authorMarcel,
  authors.authorAdam,
  authors.authorWojciech,
]

export const renderCards = (secondView = false) => {
  const avatars = useAvatars()
  const list = arrAuthors.map(
    ({ authorName, authorJob, linkedInProfile, mail, authorDesc }, i) => {
      return secondView ? (
        <StyledSecondCard key={authorName}>
          <Avatar
            fluid={avatars[i].childImageSharp.fluid}
            alt={authorName}
            title={`${authorName} - ${authorJob}`}
          />
          <div className="profile-content">
            <ExtendStyledTitle>{authorName}</ExtendStyledTitle>
            <p className="job">{authorJob}</p>
            <p className="desc">{authorDesc}</p>
            <Socials>
              <a href={`mailto:${mail}`}>
                <img
                  src={mailIcon}
                  alt="E-mail"
                  title={`E-mail to ${authorName}`}
                />
              </a>
              <a href={linkedInProfile}>
                <img
                  src={linkedIcon}
                  alt="LinkedIn Profile"
                  title={`${authorName} - LinkedIn Profile`}
                />
              </a>
            </Socials>
          </div>
        </StyledSecondCard>
      ) : (
        <StyledCard key={authorName}>
          <Avatar
            fluid={avatars[i].childImageSharp.fluid}
            alt={authorName}
            title={`${authorName} - ${authorJob}`}
          />
          <div className="profile-content">
            <ExtendStyledTitle>{authorName}</ExtendStyledTitle>
            <p>{authorJob}</p>
            <Socials>
              <a href={`mailto:${mail}`}>
                <img
                  src={mailIcon}
                  alt="E-mail"
                  title={`E-mail to ${authorName}`}
                />
              </a>
              <a href={linkedInProfile}>
                <img
                  src={linkedIcon}
                  alt="LinkedIn Profile"
                  title={`${authorName} - LinkedIn Profile`}
                />
              </a>
            </Socials>
          </div>
        </StyledCard>
      )
    }
  )
  return list
}
